<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>单位信息审核</h3></div>
    <el-form
      :inline="!UI.isMobile"
      :label-position="UI.isMobile ? 'top' : 'right'"
      size="mini"
      :model="filterForm"
    >
      <el-form-item label="单位名">
        <el-input
          clearable
          v-model="filterForm.organization"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="是否审核通过">
        <el-select v-model="filterForm.is_approved">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, key) in $approveConsts"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            flushData();
          "
        >
          查询
        </el-button>
        <el-button
          @click="
            filterForm = { page: 1, page_size: 10 };
            flushData();
          "
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
      @expand-change="onExpandChange"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <div style="margin-left: 47px; margin-right: 180px" v-loading="props.row.loading">
            <el-table :data="props.row.players" border v-if="props.row.players && props.row.players.length > 0">
              <el-table-column label="ID">
                <template slot-scope="scope">
                  {{ scope.row.user_info.user_id  }}
                </template>
              </el-table-column>

              <el-table-column label="姓名">
                <template slot-scope="scope">
                  {{ scope.row.user_info.name  }}
                </template>
              </el-table-column>
              <el-table-column label="ID">
                <template slot-scope="scope">
                  {{ scope.row.user_info.user_id  }}
                </template>
              </el-table-column>

              <el-table-column label="姓名">
                <template slot-scope="scope">
                  {{ scope.row.user_info.name  }}
                </template>
              </el-table-column>

              <el-table-column label="性别" >
                <template slot-scope="scope">
                  {{ scope.row.user_info.sex == 0 ? '男' : '女' }}
                </template>
              </el-table-column>

              <el-table-column label="籍贯">
                <template slot-scope="scope">
                  {{ scope.row.user_info.native_place.join() }}
                </template>
              </el-table-column>

              <el-table-column
                label="民族"
              >
              <template slot-scope="scope">
                {{ scope.row.user_info.nation}}
              </template>
              </el-table-column>

              <el-table-column
                label="状态"
              >
              <template slot-scope="scope">
                {{ $getApproveLabel(scope.row.user_info.is_approved) }}
              </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="organization" label="单位名"></el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column
        prop="contact"
        label="联系人"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column
        prop="contact_phone"
        label="联系电话"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column
        prop="contact_mobile"
        label="联系手机"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column
        prop="email"
        label="邮箱"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column label="认证文件" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              fileUrl = scope.row.auth_file;
              isShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-tag size="small" :type="approveBtn[scope.row.is_approved]">
            {{ $getApproveLabel(scope.row.is_approved) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="查看信息" v-else>
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              info = scope.row;
              isInfoShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            @click="approve(scope.row.id, $approveConsts.APPROVED.value)"
            type="success"
            size="small"
            :disabled="scope.row.is_approved == $approveConsts.APPROVED.value"
          >
            通过
          </el-button>
          <el-button
            @click="approve(scope.row.id, $approveConsts.REJECTED.value)"
            type="danger"
            size="small"
            :disabled="scope.row.is_approved == $approveConsts.REJECTED.value"
          >
            驳回
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isInfoShow"
      width="98%"
      v-if="UI.isMobile"
    >
      <div class="padding-xs">
        <el-descriptions :column="1" border>
          <el-descriptions-item
            v-for="(value, key) in info"
            :key="key"
            :label="key"
          >
            <div v-if="!(value + '').startsWith('http')">{{ value }}</div>
            <div v-else>
              <el-button
                type="primary"
                size="small"
                @click="
                  fileUrl = value;
                  isShow = true;
                "
              >
                点击查看
              </el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="isShow"
      width="800px"
      show-close
      :fullscreen="UI.isMobile"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;"></img>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrganizationList,
  orgApprove,
  getPlayersOfOrg,
} from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';

export default {
  components: {
    pdf,
  },

  data() {
    return {
      info: {},
      isInfoShow: false,
      isShow: false,
      fileUrl: '',
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      approveBtn: ['warning', 'success', 'danger', 'info'],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    onExpandChange: function (row, expandedRows) {
      let that = this;
      if (row.players && row.players.length > 0){
        return 
      }
      getPlayersOfOrg(row.id, function (res) {
        for (let item of that.tableData) {
          if (item.id == row.id) {
            item.players = res;
            item.loading = false;
            break;
          }
        }
      });
    },

    flushData: function () {
      let that = this;
      getOrganizationList(this.filterForm, function (res) {
        that.tableData = [];

        res.items.forEach((item) => {
          item.loading = true;
          that.tableData.push(item)
        });
       
        that.total = res.total;
      });
    },

    approve: function (orgId, state) {
      let that = this;
      orgApprove(orgId, state, function (res) {
        showSuccessMsg(res);
        that.flushData();
      });
    },

    handleCurrentChange: function () {
      this.flushData();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/approve/org.vue